<template>
	<MobileLayout :showTopBar="false">
		<div class="mobile-user-page" :class="{ 'fade-in': animateIn }">
			<div class="ui-wrap">
				<div class="ui-content">
					<div class="ui-card">
						<div class="ui-tabs">
							<button class="ui-tab" :class="{ active: customerType === 'private' }"
								@click="customerType = 'private'">Private Customer</button>
							<span class="ui-sep">|</span>
							<button class="ui-tab" :class="{ active: customerType === 'trader' }"
								@click="customerType = 'trader'">Trade</button>
						</div>

						<!-- 登录表单 -->
						<form v-if="!isRegister && !isForgot" class="ui-form" @submit.prevent="handleLogin">
							<div class="ui-field">
								<input type="email" v-model="form.email" placeholder="Email" required
									style="font-family: 'Apercu-Medium', sans-serif;" />
							</div>
							<div class="ui-field">
								<input type="password" v-model="form.password" placeholder="Password" required
									style="font-family: 'Apercu-Medium', sans-serif;" />
							</div>
							<div class="ui-actions">
								<button class="ui-link font-apercu-medium" type="button" @click="switchToForgot">Forget
									Your Password?</button>
								<button class="ui-submit font-apercu-medium" type="submit">[Submit]</button>
							</div>
						</form>

						<!-- 注册表单 -->
						<form v-else-if="isRegister" class="ui-form" @submit.prevent="handleRegister">
							<div class="ui-field">
								<input type="email" v-model="registerForm.Email" placeholder="Email" required />
							</div>
							<div class="ui-field">
								<input type="password" v-model="registerForm.Password" placeholder="Password"
									required />
							</div>
							<div class="ui-field">
								<input type="text" v-model="registerForm.FirstName" placeholder="First Name" required />
							</div>
							<div class="ui-field">
								<input type="text" v-model="registerForm.LastName" placeholder="Last Name" required />
							</div>
							<div class="ui-field" v-if="customerType === 'trader'">
								<input type="text" v-model="registerForm.CompanyName" placeholder="Company" />
							</div>
							<div class="ui-field" v-if="customerType === 'trader'">
								<input type="text" v-model="registerForm.Position" placeholder="Position" />
							</div>
							<div class="ui-field">
								<input type="text" v-model="registerForm.Phone" placeholder="Phone" />
							</div>
							<div class="ui-field">
								<input type="text" v-model="registerForm.Country" placeholder="Country" />
							</div>
							<div class="ui-actions">
								<button class="ui-link font-apercu-medium" type="button" @click="switchToLogin">Back to
									Login</button>
								<button class="ui-submit font-apercu-medium" type="submit">[Submit]</button>
							</div>
						</form>

						<!-- 忘记密码表单 -->
						<form v-else-if="isForgot" class="ui-form" @submit.prevent="handleForgotPassword">
							<div class="ui-field" style="display: flex; align-items: center; gap: 8px;">
								<input type="email" v-model="forgotForm.email" placeholder="Email" required
									style="flex: 1;" />
							</div>
							<div style="text-align: right;">
								<button type="button" class="send-code-btn" @click="sendVerificationCode"
									:disabled="codeSending">
									{{ codeSending ? 'Sending...' : 'Get Code' }}
								</button>
							</div>
							<div class="ui-field">
								<input type="text" v-model="forgotForm.code" placeholder="Code" required />
							</div>
							<div class="ui-field">
								<input type="password" v-model="forgotForm.password" placeholder="Password" required />
							</div>
							<div class="ui-actions">
								<button class="ui-link font-apercu-medium" type="button" @click="switchToLogin">Back to
									Login</button>
								<button class="ui-submit font-apercu-medium" type="submit">[Submit]</button>
							</div>
						</form>

						<!-- 切换链接 -->
						<button v-if="!isRegister && !isForgot" class="ui-create font-apercu-medium" type="button"
							@click="switchToRegister" style="z-index: 99;">
							{{ customerType === 'private' ? 'Create an Account' : 'Create Trade Account' }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<!--  <div class="acct-illustration" >
      <img src="@/assets/mobile/userInfo/bg2.png" alt="" style="z-index: 9;">
    </div> -->
	</MobileLayout>
</template>

<script>
	import MobileLayout from '@/components/mobile/MobileLayout.vue'
	import {
		loginUser,
		registerUser,
		forgotpassword,
		changepassword
	} from '@/api/user'
	import {
		setToken,
		setUser
	} from '@/config/auth'
	import {
		showMessage
	} from '@/config/message'
	import {
		addToCart
	} from '@/api/Enquiry'
	import {
		getLocalCart,
		clearLocalCart
	} from '@/utils/localCart'

	export default {
		name: 'MobileUserInfo',
		components: {
			MobileLayout
		},
		data() {
			return {
				customerType: 'private',
				isRegister: false,
				isForgot: false,
				codeSending: false,
				animateIn: false, // 控制淡入动画
				form: {
					email: '',
					password: ''
				},
				registerForm: {
					Email: '',
					Password: '',
					FirstName: '',
					LastName: '',
					UserType: 'Private',
					CompanyName: '',
					Position: '',
					Phone: '',
					IsSubscribed: false,
					Country: ''
				},
				forgotForm: {
					email: '',
					code: '',
					password: ''
				},
				redirectTimer: null,
				redirectPath: '/'
			}
		},
		watch: {
			customerType(newVal) {
				this.registerForm.UserType = newVal === 'private' ? 'Private' : 'Trader'
				if (newVal === 'private') {
					this.registerForm.CompanyName = ''
					this.registerForm.Position = ''
				}
			},
			$route: {
				handler(to) {
					if (to.path === '/m/userinfo') {
						// 路由切换时重置动画
						this.animateIn = false
						this.$nextTick(() => {
							this.animateIn = true
						})
					}
				},
				immediate: true
			}
		},
		mounted() {
			// 检测是否以注册模式进入
			if (this.$route.query.mode === 'register') {
				this.isRegister = true
				this.isForgot = false
				// 确保注册表单的 UserType 与当前 customerType 一致（已在 watch 中处理）
			}

			// ★ 触发 page-ready，消除白屏（放在 nextTick 确保 DOM 已就绪）
			this.$nextTick(() => {
				window.dispatchEvent(new Event('page-ready'))
			})

			// 触发淡入动画
			this.$nextTick(() => {
				this.animateIn = true
			})

			const redirect = this.$route.query.redirect
			if (redirect) {
				this.redirectPath = redirect
			} else {
				if (window.history.length > 1 && document.referrer) {
					this.redirectPath = 'back'
				} else {
					this.redirectPath = '/'
				}
			}
		},
		beforeDestroy() {
			if (this.redirectTimer) clearTimeout(this.redirectTimer)
		},
		methods: {
			async syncLocalCartToServer(userId) {
				const localItems = getLocalCart()
				if (localItems.length === 0) return
				const promises = localItems.map(item => {
					const model = {
						ProductID: item.ProductID,
						UserID: userId,
						CustomisationText: item.customizationText || ''
					}
					return addToCart(model).then(res => res && res.retCode === 1)
				})
				const results = await Promise.all(promises)
				const successCount = results.filter(r => r === true).length
				if (successCount > 0) {
					showMessage(`Synced ${successCount} item(s) to server`, 'success')
				}
				clearLocalCart()
			},
			switchToRegister() {
				this.isRegister = true
				this.isForgot = false
				this.registerForm.UserType = this.customerType === 'private' ? 'Private' : 'Trader'
			},
			switchToLogin() {
				this.isRegister = false
				this.isForgot = false
			},
			switchToForgot() {
				this.isForgot = true
				this.isRegister = false
			},
			async handleLogin() {
				try {
					const payload = {
						Email: this.form.email,
						Password: this.form.password
					}
					const result = await loginUser(payload)
					if (result && result.retCode === 1) {
						let token = '',
							userInfo = null
						if (typeof result === 'string') token = result
						else if (result && typeof result === 'object') {
							token = result.token || null
							userInfo = result.result || null
						}
						if (token) setToken(token)
						if (userInfo) setUser(userInfo)

						window.dispatchEvent(new CustomEvent('mobile-login-success'))
						if (userInfo) {
							await this.syncLocalCartToServer(userInfo.UserID)
						}
						this.$router.replace('/m/account')
					} else {
						showMessage(result.retMsg || 'Login failed', 'error')
					}
				} catch (error) {
					console.error('Login failed:', error)
					showMessage('Login failed', 'error')
				}
			},
			async handleRegister() {
				if (!this.validateRegisterForm()) return
				try {
					const result = await registerUser(this.registerForm)
					if (result && result.retCode === 1) {
						showMessage(result.retMsg || 'Register success', 'success')
						if (result.token) setToken(result.token)
						if (result.result) setUser(result.result)
						this.switchToLogin()
						if (result.result) {
							await this.syncLocalCartToServer(result.result.UserID)
						}
						this.redirectTimer = setTimeout(() => {
							if (this.redirectPath === 'back') {
								this.$router.go(-1)
							} else {
								this.$router.replace(this.redirectPath)
							}
						}, 500)
					} else {
						showMessage(result.retMsg || 'Registration failed', 'error')
					}
				} catch (error) {
					console.error('Register failed:', error)
					showMessage('Register failed', 'error')
				}
			},
			validateRegisterForm() {
				const {
					Email,
					Password,
					FirstName,
					LastName,
					CompanyName,
					Position
				} = this.registerForm
				if (!Email) {
					showMessage('Email is required', 'error');
					return false
				}
				if (!Password) {
					showMessage('Password is required', 'error');
					return false
				}
				if (!FirstName) {
					showMessage('First name is required', 'error');
					return false
				}
				if (!LastName) {
					showMessage('Last name is required', 'error');
					return false
				}
				 
				if (this.customerType === 'trader') {
					if (!CompanyName) {
						showMessage('Company name is required for trader', 'error');
						return false
					}
					if (!Position) {
						showMessage('Position is required for trader', 'error');
						return false
					}
				}
				return true
			},
			async sendVerificationCode() {
				const email = this.forgotForm.email
				if (!email) {
					showMessage('Please enter your email', 'error');
					return
				}
				const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
				if (!emailRegex.test(email)) {
					showMessage('Please enter a valid email address', 'error');
					return
				}
				this.codeSending = true
				try {
					const result = await forgotpassword(email)
					showMessage(result.retMsg || 'Verification code sent', 'success')
				} catch (error) {
					showMessage(error.message || 'Failed to send code', 'error')
				} finally {
					this.codeSending = false
				}
			},
			async handleForgotPassword() {
				const {
					email,
					code,
					password
				} = this.forgotForm
				if (!email || !code || !password) {
					showMessage('Please fill in all fields', 'error');
					return
				}
				try {
					const result = await changepassword({
						Email: email,
						Code: code,
						NewPassword: password
					})
					showMessage(result.retMsg || 'Password reset successfully', 'success')
					this.switchToLogin()
				} catch (error) {
					showMessage(error.message || 'Reset failed', 'error')
				}
			}
		}
	}
</script>

<style scoped>
	/* ===== 进入淡入动画 ===== */
	.mobile-user-page {
		opacity: 0;
		transition: opacity 0.7s ease;
	}

	.mobile-user-page.fade-in {
		opacity: 1;
	}

	/* ===== 原有样式 ===== */
	.mobile-user-page {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		height: 100dvh;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior: none;
		background: #fff;
	}

	.ui-wrap {
		display: flex;
		flex-direction: column;
		font-family: 'Apercu-Medium', sans-serif !important;
		flex: 1;
	}

	.ui-content {
		flex: 1;
		min-height: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 90rem 60rem 0;
		gap: 36rem;
		position: relative;
	}

	.ui-card {
		width: 100%;
		max-width: 300rem;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.ui-tabs {
		display: flex;
		align-items: center;
		gap: 10rem;
		font-size: 20rem;
		font-weight: 500;
		margin-bottom: 30rem;
	}

	.ui-tab {
		background: none;
		border: none;
		padding: 0;
		color: #999;
		font-size: 16rem;
		font-weight: 500;
		font-family: 'Apercu-Medium', sans-serif !important;
	}

	.ui-tab.active {
		color: #000;
	}

	.ui-sep {
		color: #000;
	}

	.ui-form {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 16rem;
		margin-top: 52rem;
	}

	.ui-field {
		display: flex;
		align-items: center;
		gap: 12rem;
		border-bottom: 2rem solid #000;
		padding-bottom: 8rem;
	}

	.ui-field label {
		font-size: 13rem;
		font-weight: 500;
		color: #000;
		min-width: 72rem;
		transition: opacity 0.25s ease;
	}

	.ui-field input {
		border: none;
		outline: none;
		background: transparent;
		flex: 1;
		font-size: 13rem;
		color: #000;
	}

	input::placeholder {
		color: #000;
		font-weight: 500;
	}

	.ui-actions {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 14rem;
	}

	.ui-link {
		background: none;
		border: none;
		padding: 0;
		font-size: 13rem;
		color: #000;
	}

	.ui-submit {
		background: none;
		border: none;
		padding: 0;
		font-size: 13rem;
		color: #000;
	}

	.ui-create {
		margin-top: 60rem;
		background: none;
		border: none;
		padding: 0;
		font-size: 13rem;
		color: #000;
	}

	.acct-illustration {
		position: fixed;
		bottom: 55rem;
		left: 50%;
		transform: translateX(-50%);
		width: 90%;
		opacity: 0.35;
		z-index: 0;
		display: flex;
		justify-content: center;
		pointer-events: none;
	}

	.acct-illustration img {
		width: 90%;
		height: auto;
		max-height: 518rem;
		display: block;
	}

	.ui-illustration-text {
		margin-top: 80rem;
		margin-bottom: 0;
		font-size: 10rem;
		font-weight: 500;
	}

	.ui-illustration-text p {
		width: 294rem;
		color: #00000080;
	}

	.send-code-btn {
		background: none;
		border: none;
		font-family: inherit;
		font-size: 13rem;
		cursor: pointer;
		padding: 0 0 0 8rem;
		white-space: nowrap;
		color: #000;
		text-decoration: underline;
	}

	.send-code-btn:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
</style>